import { render, staticRenderFns } from "./CountryCard.vue?vue&type=template&id=566a1db4&"
import script from "./CountryCard.vue?vue&type=script&lang=js&"
export * from "./CountryCard.vue?vue&type=script&lang=js&"
import style0 from "./CountryCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports